import _ from "lodash";
import { flattenColumn } from "./_helpers";
export function getNeededColumnsForHistory(data, graphObject) {
    var m = graphObject.mapping;
    var columns = ['_date', '_month', '_week', '_year'];
    if (isArrayOfMaps(m)) {
        columns = columns.concat(m.map(function (c) { return c.column; }));
    }
    m.forEach(function (m) {
        while (true) {
            if (isArrayOfMaps(m)) {
                columns = columns.concat(m.map(function (c) { return c.column; }));
                return;
            }
            else if (m[0]) {
                m = m[0];
            }
            else {
                return;
            }
        }
    });
    return columns;
}
export function getNeededColumnsForHistoryV2(data, mapping) {
    var m = mapping.parameters;
    var columns = ['_date', '_month', '_week', '_year', '_yearmonth'];
    for (var _i = 0, m_1 = m; _i < m_1.length; _i++) {
        var n = m_1[_i];
        columns = columns.concat(n.map(function (o) { return flattenColumn(o.column); }));
    }
    return columns;
}
export function isArrayOfMaps(o) {
    return (o[0] && o[0].column != undefined && o[0].label != undefined) ? true : false;
}
export function groupByMonths(newData, neededColumns) {
    var array = [];
    var groupedData = _.groupBy(newData, function (w) { return w._month.toString() + w._year.toString(); });
    var groupedArray = Object.values(groupedData).sort(function (a, b) { return +new Date(b[0]._date) - +new Date(a[0]._date); });
    for (var _i = 0, groupedArray_1 = groupedArray; _i < groupedArray_1.length; _i++) {
        var group = groupedArray_1[_i];
        group.sort(function (a, b) { return (a._year.toString() + a._week.toString()) - (b._year.toString() + b._week.toString()); });
        if (new Date(group.reverse()[0]._date).getDate() <= 7) {
            var o = {};
            for (var _a = 0, neededColumns_1 = neededColumns; _a < neededColumns_1.length; _a++) {
                var column = neededColumns_1[_a];
                if (group[0][column] !== null) {
                    o[column] = group[0][column];
                }
            }
            array.push(o);
        }
    }
    return array;
}
export function filterWeeks(data, neededColumns) {
    var array = [];
    var hasEnoughData;
    for (var _i = 0, _a = data.slice(0, data.length - 1); _i < _a.length; _i++) {
        var week = _a[_i];
        hasEnoughData = true;
        var clearWeek = {};
        for (var _b = 0, neededColumns_2 = neededColumns; _b < neededColumns_2.length; _b++) {
            var column = neededColumns_2[_b];
            if (week[column] !== null && week[column] !== undefined) {
                clearWeek[column] = week[column];
            }
            else {
                console.log("column not found : " + column);
                hasEnoughData = false;
            }
        }
        if (hasEnoughData) {
            array.push(clearWeek);
        }
        else {
            //  console.log('lacking data');
        }
    }
    return array;
}
export function filterWeeksPlusColour(data, neededColumns) {
    var o = {
        colour: this.graphObject.mapping[0].colour
    };
    for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
        var p = _a[_i];
        if (neededColumns.indexOf(p[0]) > -1) {
            o[p[0]] = p[1] !== null ? p[1] : 0;
        }
    }
}
export function trimLatest(week, neededColumns) {
    var latestData;
    for (var _i = 0, neededColumns_3 = neededColumns; _i < neededColumns_3.length; _i++) {
        var column = neededColumns_3[_i];
        if (week[column] !== null) {
            latestData[column] = week[column];
        }
    }
    return latestData;
}
export function parseHistoryForStackedArea(mapping, rawData) {
    var data = [];
    var m;
    for (var _i = 0, rawData_1 = rawData; _i < rawData_1.length; _i++) {
        var week = rawData_1[_i];
        var o = {};
        var legit = true;
        var columns = [].concat.apply([], mapping.parameters[0].map(function (map) { return map.column; }));
        var _loop_1 = function (column) {
            m = mapping.parameters[0].find(function (map) { return map.column === column; });
            o[column] = week[column];
            o['_date'] = week['_date'];
            o['gemeente'] = week['gemeente'];
            o['label'] = m.label;
            o['colour'] = m.colour;
            if (o[column] === null) {
                legit = false;
            }
        };
        for (var _a = 0, columns_1 = columns; _a < columns_1.length; _a++) {
            var column = columns_1[_a];
            _loop_1(column);
        }
        if (legit) {
            data.push(o);
        }
    }
    data.sort(function (a, b) {
        return new Date(a._date).getTime() - new Date(b._date).getTime();
    });
    return data;
}
